import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import {
  setReportGasMovementsFilters,
  getReportGasMovementsAction
} from "redux/actions/Reports/reportGasMovements/reportGasMovementsActions";


export const ReportGasMovementsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportGasMovements }) => reportGasMovements);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportGasMovementsAction({ startDate, endDate, station, isPdf }))
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de Bonificacion de Gas" icon={<AssessmentIcon />} >
      {isLoadingComp?.loadingReportGasMovements ? <LoadingComponent /> :
        <TableInputs
          reducer="reportGasMovements"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportGasMovementsFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) => handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
